import { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import LightBox from "components/layout/LightBox";
import useAPI from "../../hooks/useAPI";
import "swiper/css";
import "./ProductDetailsSlider.scss";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const ProductDetailsSlider = ({ product }) => {
    const api = useAPI();
    const [imageId, setImageId] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);
    const mainSwiperRef = useRef(null);
    const thumbnailStripRef = useRef(null);

    const images = product?.gallery ?? [];

    const updateMainSwiper = (index) => {
        if (mainSwiperRef.current && mainSwiperRef.current.swiper) {
            mainSwiperRef.current.swiper.slideToLoop(index);
        }
    };

    useEffect(() => {
        updateMainSwiper(currentIndex);

        const strip = thumbnailStripRef.current;
        const selected = strip?.children[currentIndex];
        if (strip && selected) {
            strip.scrollTo({ left: selected.offsetLeft - (strip.clientWidth - selected.clientWidth) / 2, behavior: "smooth" });
        }
    }, [currentIndex]);

    return (
        <>
            <div className="product-details-slider-container">
                {images.length > 0 ? (
                    <Swiper
                        ref={mainSwiperRef}
                        loop={images.length > 1}
                        className="main-slider"
                        onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
                        initialSlide={currentIndex}
                    >
                        {images.map(({ image_data }, index) => (
                            <SwiperSlide key={index}>
                                <div className="main-slide">
                                    <img alt={`Product ${index + 1}`} src={image_data.url} onClick={() => setImageId(index)} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <img className="missing-image" src={api.buildPath("/configuration/images/presentation/basic/missing")} alt="Product not available" />
                )}

                {images.length > 1 && (
                    <div className="thumbnail-controls">
                        <button className="thumbnail-arrow" type="button" aria-label="Prethodna slika" onClick={() => setCurrentIndex((index) => (index - 1 + images.length) % images.length)}>
                            <KeyboardArrowLeftIcon />
                        </button>
                        <div className="thumbnail-strip" ref={thumbnailStripRef}>
                            {images.map(({ image_data }, index) => (
                                <button
                                    className={`thumbnail-slide ${index === currentIndex ? "active" : ""}`}
                                    type="button"
                                    aria-label={`Prikaži sliku ${index + 1}`}
                                    aria-pressed={index === currentIndex}
                                    onClick={() => setCurrentIndex(index)}
                                    key={index}
                                >
                                    <img src={image_data.url} alt="" />
                                </button>
                            ))}
                        </div>
                        <button className="thumbnail-arrow" type="button" aria-label="Sledeća slika" onClick={() => setCurrentIndex((index) => (index + 1) % images.length)}>
                            <KeyboardArrowRightIcon />
                        </button>
                    </div>
                )}
            </div>

            {imageId !== undefined && <LightBox openId={imageId} gallery={images} setImageId={setImageId} setCurrentIndex={setCurrentIndex} currentIndex={currentIndex} />}
        </>
    );
};

export default ProductDetailsSlider;
